import { useAuth0 } from '@auth0/auth0-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createSupplier } from '../../../../common/api/clients/company.api';
import { queries } from '../../../../common/api/queryKeys/queries';
import { SessionService } from '../../../../user/session/SessionService';

export const useSupplierCreate = () => {
    const queryClient = useQueryClient();
    const { getAccessTokenSilently } = useAuth0();

    return useMutation({
        mutationFn: createSupplier,
        onSuccess: async () => {
            const accessToken = await getAccessTokenSilently({ cacheMode: 'off' });
            const freshRoleData = await SessionService.getInstance().loadRoleInformation(accessToken);
            queryClient.setQueryData(queries.role.information.queryKey, freshRoleData);
            return queryClient.invalidateQueries({ queryKey: queries.suppliers._def });
        },
    });
};
